// extracted by mini-css-extract-plugin
module.exports = {"ArticleBig":"styles_ArticleBig__3c27u","article":"styles_article__3nTQ1"};